var map = {
	"./Africa.svg": 96,
	"./Antarctica.svg": 97,
	"./Asia.svg": 98,
	"./Europe.svg": 99,
	"./North America.svg": 100,
	"./Oceania.svg": 101,
	"./Otro.svg": 102,
	"./South America.svg": 103,
	"./Todos.svg": 104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;